import { ApolloLink } from '@apollo/client';
import unionObjectTypesMap from '../../schema/unionObjectTypesMap.json';
import anonymousTypes from '../../schema/anonymousTypes.json';
import createV1ApolloLink from './createV1ApolloLink';
import getPossibleTypes from './utils/getPossibleTypes';
export default function getV1SchemaConfig(apolloLinks) {
    return {
        gql: {
            apolloLink: ApolloLink.from([
                ...apolloLinks,
                createV1ApolloLink(unionObjectTypesMap)
            ]),
            possibleTypes: getPossibleTypes(unionObjectTypesMap),
            anonymousTypes
        }
    };
}

//# sourceMappingURL=getV1SchemaConfig.js.map